import React from "react";
import styled from "styled-components";

function Hero() {
  return (
    <Container>
      <Description>
        <TagLine>
          <p>More than Faster</p>
        </TagLine>
        <HeadLine>
          Groceries delivered in as little as
          <span> 2 hours</span>
        </HeadLine>
        <Desc>
          Grocen atssures fresh grocery every morning to your family without
          getting out in this pandemic.
        </Desc>
        <CTA>
          <button>Order Now</button>
        </CTA>
      </Description>
      <Image>
        <img src="./HeroImage.png" alt="" />
      </Image>
    </Container>
  );
}

const Container = styled.div`
  margin: auto;
  width: 80%;

  display: flex;
  padding: 40px 0;
  align-items: center;
  justify-content: space-around;

  @media only screen and (max-width: 767px) {
    /* Styles */

    flex-direction: column;
    width: 90%;
  }
`;
const Description = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  @media only screen and (max-width: 767px) {
    /* Styles */

    width: 100%;
  }
`;
const Image = styled.div`
  width: 50%;

  @media only screen and (max-width: 767px) {
    /* Styles */
    width: 100%;
    margin-top: 40px;
  }
  img {
    width: 100%;
  }
`;
const TagLine = styled.div`
  background: #fdecec;
  border-radius: 23px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  width: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  height: 45px;
  /* identical to box height, or 100% */

  display: flex;
  align-items: center;

  color: #f55556;

  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    /* Styles */
    font-size: 12px;
    width: 140px;
  }
`;
const HeadLine = styled.h2`
  font-family: "Poppins";
  font-style: normal;
  font-weight: bold;
  font-size: 60px;
  line-height: 70px;
  margin-top: 30px;
  /* or 119% */

  letter-spacing: -0.01em;
  margin-bottom: 10px;

  color: #2e2e2e;

  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    /* Styles */

    font-size: 40px;
    line-height: 50px;
  }

  @media only screen and (max-width: 767px) {
    /* Styles */

    font-size: 38px;
    line-height: 48px;
  }
`;
const Desc = styled.p`
  font-family: "Poppins";
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 30px;
  width: 90%;
  /* or 167% */

  letter-spacing: 0.005em;

  color: #676767;
  margin-bottom: 40px;
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    /* Styles */

    font-size: 14px;
    line-height: 20px;
  }

  @media only screen and (max-width: 767px) {
    /* Styles */

    font-size: 13px;
    line-height: 20px;
  }
`;
const CTA = styled.div`
  button {
    background: #f86061;
    border-radius: 12px;
    width: 150px;
    height: 55px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 17px;
    border: none;
    outline: none;
    line-height: 20px;
    /* identical to box height, or 100% */

    text-align: center;

    color: #fffafa;
    @media only screen and (min-width: 768px) and (max-width: 1024px) {
      /* Styles */

      width: 120px;
      height: 45px;
      font-size: 14px;
      margin-top: 10px;
    }
  }
`;
export default Hero;
